export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5484.a3938236.jpg";